import { Contract, getContractsOverviewEndpoint } from '@cp-mx/common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from '../../cp-xhr';

const { reducer, fetchData } = getSimpleDataFetchSlice<Contract[], DefaultBusinessMarketApiErrorCode>({
    dataName: 'contracts',
    fetchCallback() {
        return CpDataApi.get(getContractsOverviewEndpoint()).then(response => response.data);
    },
});
export default reducer;
export const fetchContracts = fetchData;
